import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {getTranslate, getActiveLanguage} from 'react-localize-redux';

import * as actions from '../../../actions';
import {findElement} from '../../../utils/helpers';
/**
 * Import components
 */
import FormInput from '../../forms/FormInput';

/**
 * class CircleLine
 */
class CircleLine extends Component {

    /**
     * render method
     * @returns {XML}
     */
    render() {
        return (
            <div className='row' style={{marginBottom: '10px'}}>
                <div className='col l12 s12' style={{padding: 0}}>
                    <div className='col l2'>
                        <div style={{paddingTop: '10px'}}>{this.props.translate('KRW.stepFour.form.title')} {this.props.fieldNumber}</div>
                    </div>
                    <div className='col l1'>
                        <FormInput
                            type='checkbox'
                            name={`KRW.${this.props.field.Code}`}
                            divClass='col s4 m4 l1'
                            value={this.props.field.CurrentValue}
                            checked={this.props.field.CurrentValue === '1'}
                        />
                    </div>
                    <FormInput
                        type='number'
                        fieldStyle={{marginLeft: '15px'}}
                        name={`KRW.${this.props.fieldr.Code}`}
                        value={this.props.fieldr.CurrentValue}
                        divClass='col s4 m4 l2'
                        min={findElement(this.props.fieldr.Values.Range, 'StepSize').LowerLimit}
                        max={findElement(this.props.fieldr.Values.Range, 'StepSize').UpperLimit}
                        disabled={this.props.field.CurrentValue !== '1'}
                    />
                    <FormInput
                        type='number'
                        fieldStyle={{marginLeft: '15px'}}
                        name={`KRW.${this.props.fieldPx.Code}`}
                        value={this.props.fieldPx.CurrentValue}
                        divClass='col s4 m4 l2 '
                        min={findElement(this.props.fieldPx.Values.Range, 'StepSize').LowerLimit}
                        max={findElement(this.props.fieldPx.Values.Range, 'StepSize').UpperLimit}
                        disabled={this.props.field.CurrentValue !== '1'}
                    />
                    <FormInput
                        type='number'
                        fieldStyle={{marginLeft: '15px'}}
                        name={`KRW.${this.props.fieldPy.Code}`}
                        value={this.props.fieldPy.CurrentValue}
                        divClass='col s4 m4 l2'
                        min={findElement(this.props.fieldPy.Values.Range, 'StepSize').LowerLimit}
                        max={findElement(this.props.fieldPy.Values.Range, 'StepSize').UpperLimit}
                        disabled={this.props.field.CurrentValue !== '1'}
                    />
                </div>
            </div>
        )
    }

}

CircleLine.propTypes = {
    field:        PropTypes.object,
    fieldPx:      PropTypes.object,
    fieldPy:      PropTypes.object,
    fieldr:       PropTypes.object,
    fieldNumber:  PropTypes.string,
    translate:    PropTypes.func,
    krw:          PropTypes.object,
    isValidFrom:  PropTypes.bool,
    fetchData:    PropTypes.func.isRequired,
}

function mapStateToProps({locale, krw, isvalidfrom}) {
    return {
        translate:      getTranslate(locale),
        currentLanguge: getActiveLanguage(locale).code,
        krw,
        isvalidfrom,
    }
}

export default connect(mapStateToProps, actions)(CircleLine);




// WEBPACK FOOTER //
// ./src/components/krw-steps/StepFive/CircleLine.js